<template>
  <div class="be-content" v-if="reports">
    <div class="main-content container-fluid">
      <div class="row">
        <div class="panel-heading">
          <div class="col-md-8">
            Статистика за {{filterPeriod.name}}
          </div>
          <div class="col-md-2">
            <select class="form-control input-sm" v-model="filterCity">
              <option selected value="">Все города</option>
              <option v-for="city in cities" :value="city">
                <span v-if="city!=='-'">{{city}}</span>
                <span v-else>Не указан</span>
              </option>
            </select>
            <span class="panel-subtitle" v-if="filterCity" @click="filterCity=''" style="cursor: pointer">Сбросить параметры (все города)</span>
          </div>
          <div class="col-md-2">
            <select class="form-control input-sm" v-model="filterPeriod">
              <option selected value="">За всё время</option>
              <option v-for="period in reportPeriods" :value="period">
                <span>{{period.name}}</span>
              </option>
            </select>
            <!--<span class="panel-subtitle" v-if="filterPeriod" @click="filterPeriod=''" style="cursor: pointer">Сбросить параметры (за всё время)</span>-->
          </div>
        </div>
        <table class="table table-striped table-hover table-fw-widget dataTable no-footer">
          <thead>
          <tr>
            <th>Id</th>
            <th>Оператор</th>
            <th>Город</th>
            <th width="5%" class="number">Гостей всего</th>
            <th width="7%" class="number">Из них оплативших</th>
            <th width="5%" class="number">Из них льготных</th>
            <th width="5%" class="number">Из них отказников</th>
            <th class="number">Сумма сбора</th>
            <th class="number">Сумма льгот</th>
            <th class="number">Сумма отказов</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="s in stats" v-bind:class="{'warn': s.records === 0}">
            <td>{{s.id}}</td>
            <td width="50%">
              <router-link
                :to="{name:'operator-visits', params: {operatorId: s.id}, query: getOperatorReportId(s.id)? {report: getOperatorReportId(s.id)} : null}">
                {{s.name}}
              </router-link>
            </td>
            <td>{{s.city}}</td>
            <td class="number">{{s.records}}</td>
            <td class="number">{{s.paid_records}}</td>
            <td class="number">{{s.privileged_records}}</td>
            <td class="number">{{s.refused_records}}</td>
            <td class="number">{{s.tax | amountFilter}}</td>
            <td class="number">{{s.privileged_tax | amountFilter}}</td>
            <td class="number">{{s.refused_tax | amountFilter}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: "stats",
    data: function () {
      return {
        stats: [],
        reportPeriods: null,
        filterCity: '',
        filterPeriod: null,
        reports: null
      }
    },
    created () {
      this.getReports()
      this.getCurrentReportPeriod()
      this.getReportsPeriods()
      this.getStats()
    },
    methods: {
      getStats () {
        this.axios.get('/api/stats/', {params: this.queryFilter})
          .then((response) => {
            if (response.status === 200) {
              this.stats = response.data
            }
          })
      },
      getReports () {
        this.axios.get('/api/reports')
          .then((response) => {
            if (response.status === 200) {
              this.reports = response.data
            }
          })
      },
      getReportsPeriods () {
        if (!this.reportPeriods) {
          this.axios.get('/api/reports/periods')
            .then((response) => {
              if (response.status === 200) {
                this.reportPeriods = response.data
              }
            })
        }
      },
      getCurrentReportPeriod () {
        if (!this.filterPeriod) {
          this.axios.get('/api/reports/current')
            .then((response) => {
              if (response.status === 200) {
                this.filterPeriod = response.data
              }
            })
        }
      },
      getOperatorReportId (operatorId) {
        let result = this.reports.filter(report =>
          Number(report.operator) === Number(operatorId) && report.date_start === this.filterPeriod.date_start && report.date_end === this.filterPeriod.date_end
        )
        return result.length > 0 ? result[0].id : null
      }
    },
    computed: {
      ...
        mapGetters(
          {
            operators: 'operators',
          }
        ),
      queryFilter () {
        return {
          'city': this.filterCity,
          'date_start': this.filterPeriod.date_start,
          'date_end': this.filterPeriod.date_end,
        }
      }
      ,
      cities () {
        let cities = []
        this.operators.forEach(item => (cities.push(item.city)))
        return [...new Set(cities)].sort()
      }
    }
    ,
    watch: {
      filterCity () {
        this.getStats()
      },
      filterPeriod () {
        this.getStats()
      }
    }
  }
</script>

<style scoped>
  tr.warn {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Stats.vue